var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardRemediationSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 385.1 415.3",
    style: {
      enableBackground: "new 0 0 385.1 415.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F5F5F5;}\r\n\t.st1{fill:#FFFFFF;stroke:#666666;stroke-width:10;}\r\n\t.st2{fill:#FFFFFF;stroke:#666666;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:#666666;stroke:#FFFFFF;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#666666;stroke:#FFFFFF;stroke-width:4;}\r\n\t.st6{fill:#666666;stroke:#666666;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53_00000082362503064318383830000010355994459633313940_",
    className: "st0",
    cx: 188.8,
    cy: 286.5,
    rx: 181.2,
    ry: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.2,280.6H47c-12.1,0-21.9-9.8-21.9-21.9V109.1C25.2,97,35,87.2,47,87.2h261.2c12.1,0,21.9,9.8,21.9,21.9 v149.7C330.1,270.8,320.3,280.6,308.2,280.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 26.7,
    y1: 144.3,
    x2: 328.5,
    y2: 144.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 26.7,
    y1: 184.7,
    x2: 328.5,
    y2: 184.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.9,
    y1: 236.8,
    x2: 99.8,
    y2: 236.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 125.5,
    y1: 236.8,
    x2: 178.4,
    y2: 236.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 222.7,
    y1: 44.5,
    x2: 126.3,
    y2: 326.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 217.3,
    y1: 41.8,
    x2: 120.8,
    y2: 323.4
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9878 -0.156 0.156 0.9878 -38.6197 46.304)",
    className: "st4",
    cx: 275.8,
    cy: 269.3,
    rx: 59.9,
    ry: 57.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12370_00000078024544819829009330000012411439388834272425_",
    className: "st5",
    d: "M370.3,370.8c-1.9,0-3.8-0.8-5.1-2.1 l-48-48.1c-2.7-2.9-2.6-7.5,0.3-10.2c2.8-2.6,7.1-2.6,9.9,0l48,48.1c2.8,2.8,2.8,7.4,0,10.2C374.1,370.1,372.2,370.8,370.3,370.8 L370.3,370.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12369_00000062893673962955552580000011570590944426248832_",
    className: "st5",
    d: "M276.2,341.8L276.2,341.8 c-40,0-72.4-32.4-72.4-72.4c0-40,32.4-72.4,72.4-72.4h0c40,0,72.4,32.4,72.4,72.4S316.2,341.8,276.2,341.8z M218.3,269.4 c0,32,25.9,57.9,57.9,58h0c32,0,57.9-25.9,57.9-57.9c0-32-25.9-57.9-57.9-57.9c0,0,0,0,0,0h0C244.2,211.5,218.3,237.4,218.3,269.4z "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622_00000075881945024042067880000011877598493321258421_",
    transform: "translate(593.065 2227.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6820_00000125572964461790043900000013772835979999513519_",
    className: "st6",
    d: "M-287.6-1925.2c-1.3,1.1-3.2,1-4.3-0.2 c0,0,0,0,0,0c-12.6-14-34.2-15.1-48.2-2.5c-0.9,0.8-1.7,1.6-2.5,2.5c-1.1,1.3-3.1,1.4-4.3,0.2s-1.4-3.1-0.2-4.3c0,0,0,0,0,0 c14.9-16.5,40.4-17.8,56.9-2.9c1,0.9,2,1.9,2.9,2.9C-286.2-1928.2-286.3-1926.3-287.6-1925.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821_00000135665755609880561250000010654258929175424651_",
    className: "st6",
    d: "M-292.7-1961.2 c-8.5,0-15.3-6.9-15.4-15.4c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2l0,0 c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1C-277.3-1968.1-284.2-1961.2-292.7-1961.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822_00000098202546551592692470000002218712429794082996_",
    className: "st6",
    d: "M-332.6-1976.6c0-1.7,1.4-3.1,3.1-3.1 s3.1,1.4,3.1,3.1c0,8.5-6.9,15.4-15.4,15.4c-8.5,0-15.4-6.9-15.4-15.4c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1 c0,5.1,4.1,9.2,9.2,9.2C-336.7-1967.4-332.6-1971.5-332.6-1976.6L-332.6-1976.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRemediationSad);
export default __webpack_public_path__ + "static/media/card-remediation-sad.66b6a881e530331100e059bf934912d5.svg";
export { ForwardRef as ReactComponent };